import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth';
import { ENABLED_LANGUAGES, LANGUAGE_NAMES } from '../i18n/config';

export default function PublicHeader() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();

  return (
    <header className="landing-header">
      <Link to="/" className="landing-logo">
        <span className="landing-logo-mark">
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" aria-hidden="true">
            <rect x="0.5" y="0.5" width="15" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.2" fill="none"/>
            <path d="M1 1.5L8 7L15 1.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
          </svg>
        </span>
        {t('app.name')}
      </Link>
      <nav className="public-nav">
        <NavLink to="/pricing" className={({ isActive }) => isActive ? 'public-nav-link public-nav-link--active' : 'public-nav-link'}>
          {t('nav.pricing')}
        </NavLink>
        <NavLink to="/help" className={({ isActive }) => isActive ? 'public-nav-link public-nav-link--active' : 'public-nav-link'}>
          {t('nav.help')}
        </NavLink>
        <NavLink to="/your-privacy" className={({ isActive }) => isActive ? 'public-nav-link public-nav-link--active' : 'public-nav-link'}>
          {t('nav.yourPrivacy')}
        </NavLink>
        {ENABLED_LANGUAGES.length > 1 && (
          <select
            className="public-nav-lang-select"
            value={i18n.resolvedLanguage ?? i18n.language}
            onChange={e => i18n.changeLanguage(e.target.value)}
            aria-label="Language"
          >
            {ENABLED_LANGUAGES.map(lang => (
              <option key={lang} value={lang}>{LANGUAGE_NAMES[lang] ?? lang}</option>
            ))}
          </select>
        )}
        {user ? (
          <Link to="/app/dashboard" className="public-nav-signin">
            {t('nav.myAccount')}
          </Link>
        ) : (
          <a
            href="/.auth/login/google?post_login_redirect_uri=/app/dashboard"
            className="public-nav-signin"
          >
            {t('nav.signIn')}
          </a>
        )}
      </nav>
    </header>
  );
}
